<script>
import Repositories from '@/repositories';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
const OrdersRepository = Repositories.get('orders');
const KeyGenRepository = Repositories.get('keygen');
const OrderItemsRepository = Repositories.get('orderitems');
import QuantityEditor from '@/components/widgets/popovers/quantity-yes-no-editor.vue';
import dateMixin from '@/mixins/dateMixin';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';
const SingleConfigRepository = Repositories.get('singleconfigs');
import { DEFAULT_EMAILS } from '@/mixins/defaultEmail.js';

export default {
  components: {
    Loading,
    QuantityEditor,
    DatePicker,
  },
  mixins: [dateMixin, DEFAULT_EMAILS],
  props: {
    order: Object,
    modalId: { type: String, default: 'confirm-order-modal' },
  },
  data() {
    return {
      isLoading: false,
      silentLoading: false,
      orgName: '',
      emailConfig: null,
      orderItemsList: [],
      gridTypes: ['attentionRequired', 'otherItems'],
      metadataEdition: {
        isEditingExternalNumber: false,
        isEditingReceptionDate: false,
        isLoadingExternalNumber: false,
        isLoadingReceptionDate: false,
        isErrorExternalNumber: false,
        isErrorReceptionDate: false,
      },
      orderExternalNumber: '',
      orderReceptionDate: '',
    };
  },
  methods: {
    modalHidden() {
      this.orderItemsList = [];
      this.$emit('modal-closed');
    },
    async modalShown() {
      this.metadataEdition = {
        isEditingExternalNumber: false,
        isEditingReceptionDate: false,
        isLoadingExternalNumber: false,
        isLoadingReceptionDate: false,
        isErrorExternalNumber: false,
        isErrorReceptionDate: false,
      };

      this.orderItemsList = [];

      if (this.order != null) {
        this.orderExternalNumber = this.order.externalNumber;
        this.orderReceptionDate = this.order.receptionDate;
      }

      try {
        this.isLoading = true;
        this.silentLoading = true;

        if (this.order != null) {
          let resp2 = await OrderItemsRepository.customREST.getByOrderWithWorkOrderItemOrderItems(
            this.order.idPublic
          );

          this.orderItemsList = resp2.data;
        }
      } catch (error) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }

      let promise1 = KeyGenRepository.customREST
        .getOrganisation()
        .then(({ data }) => (this.orgName = data.name));

      let promise2 = SingleConfigRepository.get('EmailsConfig')
        .then(({ data }) => {
          this.emailConfig = data;
        })
        .catch((e) => {
          if (e.response.status == 404) {
            this.emailConfig = [];
          } else {
            throw e.response;
          }
        });

      Promise.all([promise1, promise2])
        .then(() => {
          this.silentLoading = false;
        })
        .catch(() => {
          this.silentLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    acceptPriceGlobally(newPrice, orderItem) {
      let payload = {
        ...orderItem,
        priceUpdateType: 'globally',
        externalEditedPrice: newPrice,
      };

      this.updateOrderItem(payload);
    },
    acceptPriceLocally(newPrice, orderItem) {
      let payload = {
        ...orderItem,
        priceUpdateType: 'locally',
        externalEditedPrice: newPrice,
      };

      this.updateOrderItem(payload);
    },
    acceptPricesGlobally() {
      this.acceptPrices('globally');
    },
    acceptPricesLocally() {
      this.acceptPrices('locally');
    },
    acceptPrices(priceUpdateType) {
      this.orderItemsList.map((element) => {
        if (element.isPriceEditedExternal) {
          element.priceUpdateType = priceUpdateType;
        }

        return element;
      });
    },
    updateOrderItem(payload) {
      let foundIndex = this.orderItemsList.findIndex(
        (x) => x.idPublic == payload.idPublic
      );
      this.orderItemsList = [
        ...this.orderItemsList.slice(0, foundIndex),
        { ...payload, editedPrice: payload.externalEditedPrice },
        ...this.orderItemsList.slice(foundIndex + 1),
      ];
    },
    getRightOrderItemsList(type) {
      if (type == 'attentionRequired') {
        return this.orderItemsListComputed.filter(
          (x) => x.isPriceEditedExternal
        );
      } else {
        return this.orderItemsListComputed.filter(
          (x) => !x.isPriceEditedExternal
        );
      }
    },
    orderOrder() {
      if (this.isAnyActionNeeded) {
        return;
      }

      this.isLoading = true;

      OrdersRepository.actions
        .orderOrder(this.orderItemsList, this.order.idPublic)
        .then(() => {
          this.isLoading = false;

          this.generateMail();

          this.$emit('order-updated', {
            ...this.order,
            isOrdered: true,
            orderItems: this.orderItemsList,
          });
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
        });
    },
    generateMail() {
      window.open(this.mailtoString, '_blank');
    },
    startEditing(field) {
      this.metadataEdition[`isEditing${field}`] = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          const editInput = this.$refs[`edit${field}Input`];
          editInput.focus();
        });
      });
    },
    async save(field) {
      if (
        !this.metadataEdition.isLoadingExternalNumber &&
        !this.metadataEdition.isLoadingReceptionDate
      ) {
        this.metadataEdition[`isLoading${field}`] = true;
        this.metadataEdition[`isError${field}`] = false;

        await this.$nextTick();

        try {
          let payload = {
            ...this.order,
            externalNumber: this.orderExternalNumber,
            receptionDate: this.orderReceptionDate,
          };

          await OrdersRepository.update(payload, this.order.idPublic);

          this.$emit('order-updated', payload);

          this.metadataEdition[`isEditing${field}`] = false;
        } catch (error) {
          this.metadataEdition[`error${field}`] = true;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        }

        this.metadataEdition[`isLoading${field}`] = false;
      }
    },
    async cancel(field) {
      await this.$nextTick();

      if (this.metadataEdition[`isLoading${field}`] == false) {
        this.metadataEdition[`isEditing${field}`] = false;
      }
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
    isAnyActionNeeded() {
      return (
        this.orderItemsList.filter(
          (x) => x.isPriceEditedExternal && x.priceUpdateType == null
        ).length > 0
      );
    },
    showGlobal() {
      return this.orderItemsList.some(
        (orderItem) =>
          orderItem.itemSupplierPriceThreshold == null ||
          orderItem.itemSupplierPriceThreshold.length == 0
      );
    },
    orderItemsListComputed() {
      return this.orderItemsList.map((x) => {
        let price = x.itemSupplierPrice;

        if (x.isPriceEditedExternal) {
          price = x.externalEditedPrice;
        } else if (x.isPriceEdited) {
          price = x.editedPrice;
        }

        let priceColor = '';
        if (x.priceUpdateType == 'globally') {
          priceColor = 'text-success';
        } else if (x.priceUpdateType == 'locally') {
          priceColor = 'text-primary';
        } else if (x.isPriceEditedExternal) {
          priceColor = 'text-warning';
        }

        return {
          ...x,
          price: +Number(price).toFixed(5),
          priceColor: priceColor,
        };
      });
    },
    externalLink() {
      return (
        process.env.VUE_APP_REDIRECT_URL +
        'externals/' +
        this.order.supplierLanguage +
        '/orders/' +
        this.$store.state.user.config.organisationCode +
        '/' +
        this.order.idPublic
      );
    },
    mailtoString() {
      if (this.order != null && this.emailConfig != null) {
        let currentEmailConfig = null;
        let emailConfigIndex = this.emailConfig.findIndex(
          (x) => x.language == this.order.supplierLanguage
        );

        if (emailConfigIndex < 0) {
          let defaultConfigIndex = DEFAULT_EMAILS.findIndex(
            (x) => x.language == this.order.supplierLanguage
          );

          if (defaultConfigIndex >= 0) {
            currentEmailConfig = DEFAULT_EMAILS[defaultConfigIndex];
          }
        } else {
          currentEmailConfig = this.emailConfig[emailConfigIndex];
        }

        if (currentEmailConfig != null) {
          let title = currentEmailConfig.approvedOrderTitle
            .replaceAll('[[COMPANY]]', this.orgName)
            .replaceAll('[[EXT_NUMBER]]', this.order.externalNumber)
            .replaceAll('[[SUPPLIER]]', this.order.supplierName)
            .replaceAll('[[PO_NUMBER]]', this.order.number)
            .replaceAll('[[NUMBER_OF_ITEMS]]', this.order.totalItemsQuantity)
            .replaceAll('[[ETA_DATE]]', this.order.receptionDate)
            .replaceAll('[[LINK]]', this.externalLink);

          let message = currentEmailConfig.approvedOrderText
            .replaceAll('[[COMPANY]]', this.orgName)
            .replaceAll('[[EXT_NUMBER]]', this.order.externalNumber)
            .replaceAll('[[SUPPLIER]]', this.order.supplierName)
            .replaceAll('[[PO_NUMBER]]', this.order.number)
            .replaceAll('[[NUMBER_OF_ITEMS]]', this.order.totalItemsQuantity)
            .replaceAll('[[ETA_DATE]]', this.order.receptionDate)
            .replaceAll('[[LINK]]', this.externalLink);

          return `mailto:${this.order.supplierEmail}?subject=${title}&body=${message}`;
        }
      }

      return '';
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :id="modalId"
      scrollable
      size="xl"
      no-close-on-backdrop
      :title="$t('orders.orderr')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <div style="min-height: 50px">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#f1b44c"
          :width="70"
          :height="70"
          loader="dots"
          :is-full-page="false"
        >
        </loading>

        <b-container fluid class="p-0">
          <b-row>
            <b-col>
              <div v-if="order != null">
                <b-row>
                  <b-col>
                    <h1>{{ order.number }}</h1>
                  </b-col>
                </b-row>

                <!-- EXTERNAL NUMBER WITH EDITION -->
                <b-row class="mt-3">
                  <b-col>
                    <div style="font-weight: 500; font-size: 1.3em">
                      {{ $t('orders.externalNumber') }}
                    </div>

                    <div
                      style="
                        max-width: 300px;
                        display: flex;
                        align-items: center;
                        height: 40px;
                      "
                    >
                      <div
                        v-if="metadataEdition.isEditingExternalNumber == false"
                        style="white-space: nowrap"
                      >
                        <div
                          v-if="
                            order.externalNumber &&
                              order.externalNumber.length > 0
                          "
                          style="font-size: 1.1em"
                        >
                          {{ orderExternalNumber }}
                        </div>
                        <div v-else>
                          {{ $t('orders.noExternalNumber') }}
                        </div>
                      </div>
                      <b-input
                        v-else
                        ref="editExternalNumberInput"
                        v-model="orderExternalNumber"
                        style="font-size: 1.1em"
                        @keydown.enter.stop="save('ExternalNumber')"
                        @keydown.escape.stop="cancel('ExternalNumber')"
                        type="text"
                      ></b-input>
                      <div
                        v-if="metadataEdition.isEditingReceptionDate == false"
                      >
                        <i
                          v-if="metadataEdition.isLoadingExternalNumber"
                          id="popover-button"
                          class="fas fa-spinner fa-spin text-warning ml-3 mr-2"
                          @click="save('ExternalNumber')"
                          style="font-size: 1.5em"
                        ></i>
                        <i
                          v-else-if="metadataEdition.isErrorExternalNumber"
                          @click="save('ExternalNumber')"
                          class="fas fa-exclamation text-danger pl-3 pr-2"
                          style="cursor: pointer; font-size: 1.5em"
                        ></i>
                        <i
                          v-else-if="metadataEdition.isEditingExternalNumber"
                          id="popover-button"
                          @click="save('ExternalNumber')"
                          class="fas fa-check text-success pl-3 pr-2"
                          style="cursor: pointer; font-size: 1.5em"
                        ></i>
                        <i
                          v-else
                          id="popover-button"
                          class="fas fa-pencil-alt text-primary pl-2 pr-2"
                          @click="startEditing('ExternalNumber')"
                          style="cursor: pointer; font-size: 1.2em"
                        ></i>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <!-- RECEPTION DATE WITH EDITION -->
                <b-row class="mt-3">
                  <b-col>
                    <div style="font-weight: 500; font-size: 1.3em">
                      {{ $t('orders.receptionDate') }}
                    </div>

                    <div
                      style="
                        display: flex;
                        height: 40px;
                        align-items: center;
                        max-width: 300px;
                      "
                      @keydown.escape.stop="cancel('ReceptionDate')"
                    >
                      <div
                        v-if="metadataEdition.isEditingReceptionDate == false"
                        style="white-space: nowrap"
                      >
                        <div v-if="orderReceptionDate == null">
                          {{ $t('orders.noReceptionDate') }}
                        </div>
                        <div v-else>{{ formatDate(orderReceptionDate) }}</div>
                      </div>
                      <date-picker
                        v-else
                        ref="editReceptionDateInput"
                        v-model="orderReceptionDate"
                        :first-day-of-week="1"
                        format="YYYY-MM-DD"
                        value-type="format"
                        @input="save('ReceptionDate')"
                        style="font-size: 1.1em"
                        :lang="$i18n.locale"
                      >
                      </date-picker>
                      <div
                        v-if="metadataEdition.isEditingExternalNumber == false"
                      >
                        <i
                          v-if="metadataEdition.isLoadingReceptionDate"
                          id="popover-button"
                          class="fas fa-spinner fa-spin text-warning ml-3 mr-2"
                          @click="save('ReceptionDate')"
                          style="font-size: 1.5em"
                        ></i>
                        <i
                          v-else-if="metadataEdition.isErrorReceptionDate"
                          @click="save('ExternalNumber')"
                          class="fas fa-exclamation text-danger pl-3 pr-2"
                          style="cursor: pointer; font-size: 1.5em"
                        ></i>
                        <i
                          v-else-if="metadataEdition.isEditingReceptionDate"
                          id="popover-button"
                          @click="save('ReceptionDate')"
                          class="fas fa-check text-success pl-3 pr-2"
                          style="cursor: pointer; font-size: 1.5em"
                        ></i>
                        <i
                          v-else
                          id="popover-button"
                          class="fas fa-pencil-alt text-primary pl-2 pr-2"
                          @click="startEditing('ReceptionDate')"
                          style="cursor: pointer; font-size: 1.2em"
                        ></i>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>

        <b-container
          class="p-0"
          v-for="(gridType, index) in gridTypes"
          :key="index"
          fluid
        >
          <div v-if="getRightOrderItemsList(gridType).length > 0">
            <b-row class="no-gutters">
              <b-col class="mt-auto">
                <div style="display: flex; flex-direction: column">
                  <h4 class="mb-0 mt-4">{{ $t('general.' + gridType) }}</h4>
                </div>
              </b-col>
              <b-col v-if="index == 0" cols="4" class="mt-auto">
                <div style="display: flex; flex-direction: column">
                  <b-button
                    v-if="showGlobal"
                    @click="acceptPricesGlobally"
                    class="font-size-14"
                    variant="success"
                  >
                    {{ $t('orders.acceptPricesGlobally') }}
                  </b-button>
                  <b-button
                    @click="acceptPricesLocally"
                    class="font-size-14 mt-2"
                    variant="secondary"
                  >
                    {{ $t('orders.acceptPricesLocally') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="custom-grid-header no-gutters">
              <b-col cols="6" class="custom-grid-header-column">{{
                $t('items.item')
              }}</b-col>
              <b-col cols="2" class="custom-grid-header-column text-center">{{
                $t('items.price')
              }}</b-col>
              <b-col cols="4" class="custom-grid-header-column text-center">{{
                $t('items.quantity')
              }}</b-col>
            </b-row>
            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              color="#f1b44c"
              :width="70"
              :height="70"
              loader="dots"
              :is-full-page="false"
            >
            </loading>
            <b-row
              v-for="orderItem in getRightOrderItemsList(gridType)"
              :key="orderItem.idPublic"
              :orderItem="orderItem"
              class="custom-grid-row no-gutters"
            >
              <b-col cols="6" class="custom-grid-row-column">
                {{ orderItem.itemName }}
              </b-col>
              <b-col
                cols="2"
                :id="'popover-edit-quantity-' + orderItem.idPublic"
                class="custom-grid-row-column text-center"
                :class="orderItem.isPriceEditedExternal ? 'clickable-text' : ''"
              >
                <div :class="orderItem.priceColor">
                  {{ currencyFormatter.format(orderItem.price) }}
                </div>
                <template v-if="orderItem.isPriceEditedExternal">
                  <QuantityEditor
                    :target="'popover-edit-quantity-' + orderItem.idPublic"
                    placement="top"
                    :returnedObject="orderItem"
                    :defaultQuantity="orderItem.price"
                    :title="$t('general.editPrice')"
                    :showGlobal="
                      orderItem.itemSupplierPriceThreshold == null ||
                        orderItem.itemSupplierPriceThreshold.length == 0
                    "
                    @accept-price-globally="acceptPriceGlobally"
                    @accept-price-locally="acceptPriceLocally"
                  />
                </template>
              </b-col>
              <b-col cols="4" class="custom-grid-row-column text-center">
                {{ orderItem.totalQuantity }}
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
      <template #modal-footer>
        <b-button @click="$bvModal.hide(modalId)" size="sm" variant="danger">
          {{ $t('general.cancel') }}
        </b-button>
        <b-button
          :disabled="
            isLoading ||
              isAnyActionNeeded ||
              silentLoading ||
              metadataEdition.isLoadingExternalNumber ||
              metadataEdition.isLoadingReceptionDate
          "
          @click="orderOrder"
          size="sm"
          variant="success"
        >
          {{ $t('orders.orderr') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
